// Swiper Web Components Import
import { register } from 'swiper/element/bundle';

// Register Swiper custom elements (once, globally)
register();

// Initialize Swiper for the current DOM. Safe to call repeatedly (e.g. after a
// SWUP page swap) — already-initialized elements are skipped.
export function initSwiper() {
    const swiperEl = document.querySelector('swiper-container');

    if (swiperEl && !swiperEl.initialized) {
        // Define swiper parameters
        const swiperParams = {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                clickable: true,
            },
            navigation: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            speed: 1000,
            on: {
                init: function () {
                    console.log('Swiper initialized');
                },
            },
        };

        // Assign parameters to swiper element
        Object.assign(swiperEl, swiperParams);

        // Initialize swiper
        swiperEl.initialize();
    }
}
